import { useEffect } from 'react';
import Lenis from 'lenis';
import { LanguageProvider } from './i18n/content';
import { smooth } from './lib/smooth';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Principles } from './components/Principles';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    smooth.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      const header = document.querySelector('header');
      const headerH = header ? header.offsetHeight : 88;
      lenis.scrollTo(el, { offset: -(headerH + 24), duration: 1.2 });
    };
    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
      smooth.lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen overflow-x-clip bg-nofina-bg font-body text-white antialiased">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          <Principles />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
